import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { TaskListStateService } from '@modules/tasks/services/task-list-state.service';
import { TasksService } from '@modules/tasks/services/tasks.service';
import { Task } from '@modules/tasks/types/task';
import { TasksFilters } from '@modules/tasks/types/tasks-filters';
import { TasksListState } from '@modules/tasks/types/tasks-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-tasks-section',
  templateUrl: './tasks-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...TaskListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeTasksSectionComponent
  extends KnowledgeStitchSectionComponent<Task, TasksFilters>
  implements OnInit
{
  protected readonly listStateService = inject(TaskListStateService, { self: true });
  protected readonly stitchService = inject(TasksService);

  public override ngOnInit(): void {
    this.state = new TasksFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: TasksListState): void {
    this.filterChange.emit();

    this.filters = new TasksFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
